import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";

import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'
import IntegrationLayerEntitySearch from '../../components/integrationLayerEntitySearch/index.js'

const SearchEntityIL = () => {

    return (
        <div>
            <Header />

            <IntegrationLayerEntitySearch />

            <Footer />
        </div>
    );
}

export default SearchEntityIL;
